
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_60808_5492)","stroke":"#4A4A4A","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M2 4.5h1.441a4 4 0 013.255 1.675l2.608 3.65a4 4 0 003.255 1.675H14.5M13 3l1.5 1.5L13 6"}}),_c('path',{attrs:{"d":"M13 10l1.5 1.5L13 13M9.229 6.28l.075-.105A4 4 0 0112.559 4.5H14.5M2 11.5h1.441a4 4 0 003.255-1.675l.075-.104"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_60808_5492"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    